<template>
  <a-layout class="dict-content">
    <a-layout-sider width="220" style="background: #fff;padding:14px;margin-right:10px">
      <org-tree ref="orgTreeDom" @formTitle="addDictEvent" @formNavTitle="editDictEvent" @reGetData="reGetData"></org-tree>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 14px">
      <!-- <div class="content"> -->
      <table-data ref="tableDom"></table-data>
      <!-- </div> -->
    </a-layout-content>
  </a-layout>
</template>

<script>
import { getDictInfoByCode } from '@/api/dict'
import { mapActions } from 'vuex'

import orgTree from './modules/orgTree.vue'
import tableData from './modules/tableData.vue'
import { getSysDeptList } from '@/api/baseInfo'
import { formateTreeSelectData } from '@/utils/util'

export default {
  components: {
    orgTree, tableData
  },
  data () {
    return {
      formIptTitle: {
        formTitle: '字典详情'
      }
    }
  },
  mounted () {
    this.initDictData()
  },
  methods: {
    ...mapActions(['handleJobList', 'handleDeptList']),
    initDictData () {
      // 获取职位
      getDictInfoByCode({ pCode: 'JOB_APPLICATION' }).then(res => {
        if (res.status === 0) {
          this.handleJobList(res.data)
        }
      })
      this.initDeptData()
    },
    initDeptData () {
      // 获取部门树
      getSysDeptList({ id: 0 }).then(res => {
        if (res.status === 0) {
          const data = { children: res.data, name: '部门' }
          const formateModel = formateTreeSelectData(data, 'name', 'id')
          this.handleDeptList(formateModel.children)
          // this.deptList = formateModel.children
        }
      })
    },
    addDictEvent () {
      this.formIptTitle.formTitle = '新建字典'
    },
    editDictEvent () {
      this.formIptTitle.formTitle = '编辑字典'
    },
    handleSubmit () {
      // 表单提交成功后,重新获取树的数据
      this.$refs['orgTreeDom'].queryDictData(true)
    },
    reGetData () {
      console.log('重新获取数据')
      this.initDeptData()
      // this.$refs['tableDom'].querySysDeptList()
    }
  }
}
</script>
